import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Card, Tabs, Tooltip } from 'antd';
import ModelForm from './ModelForm';
import BizPartnerTable from './BizPartnerTable';
import CreditorDetailActions from '../../Stores/CreditorDetail/Actions';

const { TabPane } = Tabs;

class CreditorDetailScreen extends React.PureComponent {
  componentDidMount() {
    const { match, setReslId } = this.props;

    if (match.params.action === 'create') {
      setReslId(0);
    } else if (match.params.action === 'update') {
      setReslId(parseInt(match.params.id, 10));
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, appPath, model } = this.props;

    return (
      <Card title={`${intl.formatMessage({ id: 'creditor' })} ${model.code}`}>
        <Tabs type="card" activeKey={match.params.proc_type}>
          <TabPane
            tab={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Tooltip placement="bottom" title={intl.formatMessage({ id: `general` })}>
                <Link
                  style={match.params.proc_type !== 'GENERAL' ? { color: 'black' } : {}}
                  to={`${appPath}/creditorDetail/${match.params.action}/${match.params.id}/GENERAL`}
                  replace
                >
                  <FormattedMessage id="general" />
                </Link>
              </Tooltip>
            }
            key="GENERAL"
          />
          <TabPane
            tab={
              // eslint-disable-next-line react/jsx-wrap-multilines
              <Tooltip placement="bottom" title={intl.formatMessage({ id: `business_partners` })}>
                <Link
                  style={match.params.proc_type !== 'BIZ_PARTNERS' ? { color: 'black' } : {}}
                  to={`${appPath}/creditorDetail/${match.params.action}/${match.params.id}/BIZ_PARTNERS`}
                  replace
                >
                  <FormattedMessage id="business_partners" />
                </Link>
              </Tooltip>
            }
            key="BIZ_PARTNERS"
          />
        </Tabs>

        {match.params.proc_type === 'GENERAL' && <ModelForm match={match} />}
        {match.params.proc_type === 'BIZ_PARTNERS' && <BizPartnerTable match={match} />}
      </Card>
    );
  }
}

CreditorDetailScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,

  setReslId: PropTypes.func,
  model: PropTypes.shape({
    code: PropTypes.string,
    status: PropTypes.number
  })
};

CreditorDetailScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',

  setReslId() {},
  model: { code: '', status: 2 }
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,

  model: state.creditorDetail.model
});

const mapDispatchToProps = dispatch => ({
  setReslId: resId => dispatch(CreditorDetailActions.creditorDetailSetResId(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreditorDetailScreen));
